import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';

import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';

import { AlertService } from "../../../_services/alert.service";

import { environment } from "../../../../environments/environment";

import { ApiHttpService } from "../../../_services/api-http.service";
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';


const { API_URL } = environment;

@Component({
  selector: 'app-merchant-compliance',
  templateUrl: './merchant-compliance.component.html',
  styleUrls: ['./merchant-compliance.component.scss']
})
export class MerchantComplianceComponent implements OnInit {

 
  orvreport: FormGroup;
  form: FormGroup;
  Resultdata: any;
  merchantId:any;
  pageSize: number = 10;
  private filterObj: any = {};
  SingleRow: any;
  currentPage: number = 0;
  collectionSize: number = 0;

  merchantdata:any;
  type : any
  flagcheck:Boolean=false;

   flag:Boolean=false;
    tncflage:Boolean=false;
    mgpflage:Boolean=false;
    mrpflage:Boolean=false;
    aocflage:Boolean=false;  
    cocflage:Boolean=false;
    vapflage:Boolean=false;

  selectedFiletnc:any;
  selectedFilemgp:any;
  selectedFilemrp:any;
  selectedFileaoc:any;
  selectedFilecoc:any;
  selectedFilevap:any;
  merchantdis: boolean = true;
  filedis: boolean = true;



  loading: boolean = false;

  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete"
  ];
  @ViewChild('acc') private acc: NgbAccordion;
  private gridApi!: GridApi;


  // public rowData: any[];

  public rowData: any[] = [
    // Add more rows here as needed...
  ];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };
  
 
  public columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'merchantName', tooltipField: 'sp_id', headerName: 'Merchant Name'},
    { field: 'merchantId', tooltipField: 'sp_id', headerName: 'Merchant ID'},
    { field: 'fileName1', tooltipField: 'sp_id', headerName: 'Merchant Web Compliance'},
    // { field: 'fileName2', tooltipField: 'sp_id', headerName: 'Grievance Policy'},
    // { field: 'fileName5', tooltipField: 'sp_id', headerName: 'Refund Policy'},
    // { field: 'fileName6', tooltipField: 'sp_id', headerName: 'PCI-DSS AOC'},
    // { field: 'fileName3', tooltipField: 'sp_id', headerName: 'PCI-DSS COC'},
    // { field: 'fileName4', tooltipField: 'sp_id', headerName: 'VAPT Report'},
    { field: 'createDate', tooltipField: 'sp_id', headerName: 'Create Date'},
    { field: "updateDate", tooltipField: 'sp_id', headerName: 'Update Date' },
  
  
  ];


  tableSelectedColumn: ColDef[] = [...this.columnDefs];



 
  constructor(private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService, ) {

  

    this.orvreport = formBuilder.group({
      merchantId: ["", Validators.required],
      //fileuploadmgp:["",Validators.required],
      //fileuploadmrp:["",Validators.required],
      //fileuploadaoc:["",Validators.required],
      fileuploadtnc:["",Validators.required],
      //fileuploadcoc:["",Validators.required],
      //fileuploadvap:["",Validators.required],
 }) 
  }

    ngOnInit(): void {
      this.merchantdis=true;
      this.filedis=true;
     let merchantdata = { "name": "" }
    this.apiHttpService
      .post(`${API_URL}/GetMerchant`, merchantdata)
      .subscribe((res) => {
        this.Resultdata = res
      });
    }

    


    file:any;
    onFileSelectedtnc(event: Event): void {
      
      debugger
      this.filedis=true;
       const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFiletnc = inputElement.files[0];
      }

        
      if( this.selectedFiletnc.type != "application/pdf" ){
        this.flagcheck=false
        this.filedis=false;

      }else{
        this.flagcheck=true
        this.filedis=true;


      }
    }


    onFileSelectedmgp(event: Event): void {
      this.filedis=true;
       const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFilemgp = inputElement.files[0];
      }

      if( this.selectedFilemgp.type != "application/pdf" ){
        this.flagcheck=false
        this.filedis=false;

      }else{
        this.flagcheck=true
        this.filedis=true;


      }
    }
   
    onFileSelectedmrp(event: Event): void {
      this.filedis=true;
       const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFilemrp = inputElement.files[0];
      }      
      if( this.selectedFilemrp.type != "application/pdf" ){
        this.flagcheck=false
        this.filedis=false;

      }else{
        this.flagcheck=true
        this.filedis=true;
      }
    } 
    
    onFileSelectedaoc(event: Event): void {
      this.filedis=true;
       const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFileaoc= inputElement.files[0];
      }
      if( this.selectedFileaoc.type != "application/pdf" ){
        this.flagcheck=false
        this.filedis=false;
      }else{
        this.flagcheck=true
        this.filedis=true;
      }
    }
    
    onFileSelectedcoc(event: Event): void {
      this.filedis=true;
       const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFilecoc = inputElement.files[0]; }      
        if( this.selectedFilecoc.type != "application/pdf" ){
          this.flagcheck=false
          this.filedis=false;

        }else{
          this.flagcheck=true
          this.filedis=true;  
        }      
      }

    onFileSelectedvap(event: Event): void {
      this.filedis=true;
const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFilevap = inputElement.files[0];
      }

      if( this.selectedFilevap.type != "application/pdf" ){
        this.flagcheck=false
        this.filedis=false;

      }else{
        this.flagcheck=true
        this.filedis=true;


      }

      
    }

    onSubmit(formvalue: any) {
      debugger
      this.merchantdis=true;
      this.filedis=true;
if((formvalue.fileuploadmgp||formvalue.fileuploadmrp||formvalue.fileuploadaoc||formvalue.fileuploadtnc||formvalue.fileuploadcoc&&formvalue.fileuploadvap)&&(formvalue.merchantId)&&this.flagcheck){
this.merchantdis=true;
  this.filedis=true;
  this.tncflage= this.ResapiCall(this.selectedFiletnc,this.merchantId || formvalue.merchantId,"MCM_TNC");
  //  this.mgpflage=   this.ResapiCall(this.selectedFilemgp,this.merchantId || formvalue.merchantId,"MCM_MGP");
  //  this.mrpflage=   this.ResapiCall(this.selectedFilemrp,this.merchantId || formvalue.merchantId,"MCM_MRP");
  //  this.aocflage=   this.ResapiCall(this.selectedFileaoc,this.merchantId || formvalue.merchantId,"MCM_AOC");
  //  this.cocflage=   this.ResapiCall(this.selectedFilecoc,this.merchantId || formvalue.merchantId,"MCM_COC");
  //  this.vapflage=   this.ResapiCall(this.selectedFilevap,this.merchantId || formvalue.merchantId,"MCM_VAP");
  this.alertService.successAlert( "File Upload Successfully!");
  this.orvreport.reset();
}else{
  if(! formvalue.merchantId){
    this.merchantdis=false;
    }
 if( formvalue.fileuploadmgp||formvalue.fileuploadmrp||formvalue.fileuploadaoc||formvalue.fileuploadtnc||formvalue.fileuploadcoc&&formvalue.fileuploadvap){
              this.filedis=true;  } else{
              this.filedis=false; }

debugger
              if(! this.flagcheck){
                this.filedis=false;
  
              }

              
            }   
          
          }


 ResapiCall(filedata:any,merchantdata:any,type:any){
      this.flag =false;
      const formData = new FormData();
      formData.append('imageFile',filedata);
      formData.append('merchantId',  merchantdata);
      formData.append('type',type );
      this.apiHttpService
          .post(
           `${API_URL}/docs/upload`,
            //`${API_URL}/docs/upload`,
            formData  
          ).subscribe((data) => {


                  if (!data?.null) {

                    if(data.responseCode=="1111"){
                  this.flag=true                    }else if(data.responseCode=="0000"){
                   this.flag=true                     }
                    else{
                      this.flag=false                     }
                  }
                }, (error) => {
           this.alertService.errorAlert({text:"File upload fail.!"})
 });

 this.reloadonGridReady();
return this.flag
    }

    onMerchantSearch(event:Event){
      if(event){
        this.ondata(event);
      }else{
        this.reloadonGridReady();
      }}
    
    onCellClicked(param:any){
debugger
let type1
if(param.value.includes('MCM_TNC')){
  type1="MCM_TNC"
 }
//  else if(param.value.includes('MCM_MRP')){
// //   type1="MCM_MRP"
// // }else if(param.value.includes('MCM_COC')){
// //   type1="MCM_COC"
// // }else if(param.value.includes('MCM_VAP')){
// //   type1="MCM_VAP"
// // }else if(param.value.includes('MCM_MGP')){
// //   type1="MCM_MGP"
// // }else if(param.value.includes('MCM_AOC')){
// //   type1="MCM_AOC"
// }
debugger
let coldata=param.data;
 this.merchantdata=coldata.merchantId;
this.apiHttpService
.post(
  `${API_URL}/docs/download/${coldata.merchantId}/${type1}`, null
  )
.subscribe((data) => (
 this.downloadPdf(data,this.merchantdata,"MCM_TNC")
));
param.node.setExpanded(!param.node.expanded);
}
    



      onGridReady(params: GridReadyEvent<any>) {
        this.merchantdis=true;
        this.filedis=true;
        debugger
        this.loading = false

        return this.apiHttpService
        .post(
          `${API_URL}/docs/compliance/MCM_TNC/${this.currentPage}/${this.pageSize}`, null
        )
        .subscribe((data) => {
          // this.rowData = data?.data || Array.isArray(data) ? data : [],
          this.rowData = data?.data || data || [],
            this.collectionSize = this.rowData[0].totalRecords
          //  alert("1====="+this.collectionSize)
            //this.gridApi.applyTransaction({ add: this.rowData })
        });
    }
    disableUploadbtn:boolean=false
 ondata(data:any){
 this.merchantdis=true;
 this.loading = false
        return this.apiHttpService
        .post(
          `${API_URL}/docs/compliance/${data}/MCM_TNC`, null
        )
        .subscribe((data) => {
        
          this.rowData = data?.data || data || [],
            this.collectionSize = this.rowData[0]?.totalRecords                  
           console.log("JSON.stringify(this.rowData)===="+JSON.stringify(this.rowData))
           if(this.collectionSize>0){           
            this.disableUploadbtn=true
            } else{
              this.disableUploadbtn=false
            } 
        })
      
      }
  


      reloadonGridReady(){
        debugger
          this.disableUploadbtn=false
        
        
        this.loading = false
  return this.apiHttpService
        .post(
          `${API_URL}/docs/compliance/MCM_TNC/${this.currentPage}/${this.pageSize}`, null
        )
        .subscribe((data) => {
          // this.rowData = data?.data || Array.isArray(data) ? data : [],
          this.rowData = data?.data || data || [],
            this.collectionSize = this.rowData[0].totalRecords
           // this.gridApi.applyTransaction({ add: this.rowData })
        });
    
      }

  onFilterOpened(param: FilterOpenedEvent | any) {
        console.log("onFilterOpened----->", param);
      }

      onFilterModified(param: FilterModifiedEvent | any) {
        debugger
        const temp = param?.filterInstance;
        this.filterObj[param?.column?.colId] = temp;
      }
    
      onRowDoubleClicked(param: RowClickedEvent | any) {
      //   debugger
      //   let coldata=param.data;
      //  let merchant=coldata.merchantId;

      //   this.apiHttpService
      //   .post(
      //     `${API_URL}/docs/download/${coldata.merchantId}/MEC`, null
      //     )
      //   .subscribe((data) => (

          
      //    this.downloadPdf(data)


        // ));

      


        param.node.setExpanded(!param.node.expanded);
      }

      downloadPdf(data:any,merchant:any,type:any) {

        const linkSource =
        'data:application/octet-stream;base64,' +data.text;

        const downloadLink = document.createElement('a');
        const fileName = merchant+'_'+type+'.pdf';
    
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      }




      async onRowClicked(param: RowClickedEvent | any) {
        
        this.SingleRow = param.data
    
      }


      onPageSizeChanges($event: Event) {

      debugger
        this.apiHttpService
          .post(
            `${API_URL}/docs/compliance/MCM_TNC/${this.currentPage}/${this.pageSize}`, null
            )
          .subscribe((response) => {
            // this.rowData = response?.data || Array.isArray(response) ? response : [],
            this.rowData = response?.data || response || [],
            this.collectionSize = this.rowData[0].totalRecords
            //this.gridApi.applyTransaction({ add: this.rowData })
      });
    
      }




 onPaginationChange(param: PaginationChangedEvent | any) {
      debugger

      
      //this.gridApi.paginationGoToPage(param - 1)docs/compliance/MCM/${this.currentPage}/${this.pageSize}
      return this.apiHttpService
      .post(
        `${API_URL}/docs/compliance/MCM_TNC/${param}/${this.pageSize}`, null
        )
      .subscribe((response) => {

        this.rowData = response?.data || response || [],
        this.collectionSize = this.rowData[0].totalRecords
         //alert("2=="+JSON.stringify(response))
        // this.collectionSize = data[0].totalRecords;
        
        // this.rowData = (data.content?.data|| Array.isArray(data.content) ? data.content : []).map((d: any) => {
        //   return {
        //     ...d,
        //   }
        // })
      });
    }      
    // onPaginationChange(param: PaginationChangedEvent | any) {
    //   this.page=param;
    //   debugger
    //   this.gridApi.applyTransaction({remove: this.rowData})
    //    this.gridApi.showLoadingOverlay();   
    //   this.getSummaryReportData();   
    // }
}
